import { render, staticRenderFns } from "./DimensionItemList.vue?vue&type=template&id=3a50ad1a&scoped=true"
import script from "./DimensionItemList.vue?vue&type=script&lang=js"
export * from "./DimensionItemList.vue?vue&type=script&lang=js"
import style0 from "./DimensionItemList.vue?vue&type=style&index=0&id=3a50ad1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50ad1a",
  null
  
)

export default component.exports